module.exports = __webpack_public_path__ + "img/icon-time.f35d32de.svg";